export const ContentType = {
  MOVIE: 'MOVIE',
  EPISODE: 'EPISODE',
  SHOW: 'SHOW',
  LIVE: 'LIVE',
  PROGRAM: 'PROGRAM'
};

export type ContentTypeKeys = keyof typeof ContentType;
